import { deleteData, getData, postData, putData } from '../plugins/ApiCalls'

export function leadsCount() {
  return getData('leads/count')
}

export function getCompleteLeadsCount(id) {
  return getData('leads/' + id + '/count')
}

export function getPartialLeadsCount(id) {
  return getData('partial/' + id + '/count')
}

export function averageConversionRate() {
  return getData('leads/average-conversion-rate')
}

export function getLeads(data) {
  return getData('leads/list?listParams=' + encodeURIComponent(JSON.stringify(data)))
}

export function deleteLead(data) {
  return deleteData('leads/' + data.leadId)
}

export function archiveLead(data) {
  return putData('leads/' + data.leadId + '/archive')
}

export function restoreLead(data) {
  return putData('leads/' + data.leadId + '/restore')
}

export function markRead(data) {
  return postData('form-lead-view/mark-read', data, { emulateJSON: true })
}
